import React from "react";

// redux
import { connect } from "react-redux";

// themes
import { Theme1 } from "./theme";

function Footer(props) {

    // props
    const { globalAppTheme } = props

    return (
        <React.Fragment>
            {
                globalAppTheme === "theme1" &&
                <Theme1 />
            }
        </React.Fragment>
    );
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
    };
};

export default connect(getDataFromStore, null)(Footer);